'use client';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'solito/navigation';
import { getVideoDetailsESRaw, getPlayListItem } from '../api/streams/commonApi';
import { IRemoteVideoMetadata } from '../interface/videoMetadataResponse';
import { useProfileStore } from '../store/useProfileStore';

export function extractVideoId(input: string | undefined | null): string | undefined {
  if (!input) return undefined;
  return input.includes('-') ? input.split('-').pop() : input;
}

export function useVideoData(videoIdOrSlug: string | undefined | null) {
  const params = useSearchParams();
  const latitude = useProfileStore((state) => state.latitude);
  const longitude = useProfileStore((state) => state.longitude);

  const [video, setVideo] = useState<IRemoteVideoMetadata | null>(null);
  const [recommendedData, setRecommendedData] = useState<IRemoteVideoMetadata[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      try {
        setLoading(true);
        setError(null);
        const videoId = extractVideoId(videoIdOrSlug);
        if (!videoId) return;
        const details = await getVideoDetailsESRaw({ streamIds: [videoId] });
        if (!isMounted) return;
        if (details && details.length > 0) {
          setVideo(details[0]);
          const recommended = await getPlayListItem({
            offset: 0,
            count: 10,
            videoId,
            geoLatitude: latitude,
            geoLongitude: longitude,
            eventId: params?.get('eventId') ?? '-1',
          });
          if (!isMounted) return;
          if (recommended?.items) {
            setRecommendedData(recommended.items);
          } else {
            setRecommendedData([]);
          }
        } else {
          setVideo(null);
          setRecommendedData([]);
        }
      } catch (e) {
        if (!isMounted) return;
        setError(e);
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    load();
    return () => {
      isMounted = false;
    };
  }, [videoIdOrSlug, latitude, longitude]);

  return { video, recommendedData, loading, error };
}


